module.exports = __webpack_public_path__ + "img/CHECK.9cbad8d8.svg";